import React, { Component, PropTypes } from 'react'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableFooter,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import find from 'lodash/find'
import sumBy from 'lodash/sumBy'

import api from '../../../api'
import waitlistStatuses from '../../../fieldOptions/waitlistStatuses'
import ValueLink from './value-link'

const styles = {
  table: {
    maxWidth: '400px'
  }
}

class WaitlistSummary extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentWillMount () {
    this.loadCounts().then(() => {
      this.setState({ isLoaded: true })
    })
  }

  loadCounts () {
    const body = {
      filters: {
        session_sale_id: this.props.sessionSaleId
      },
      groupby: 'status'
    }

    return api.get('admin/session_waitlisters/count', { body })
      .then(res => res.json())
      .then(body => {
        this.setState({ counts: body.result })
        return body.result
      })
  }

  render () {
    if (!this.state.isLoaded) return null

    const { sessionSaleId } = this.props
    const { counts } = this.state
    const total = sumBy(counts, 'count')
    const path = `/events/session-sales/${sessionSaleId}/waitlist`

    return (
      <Card>
        <CardHeader
          title='Waitlist Summary'
        />

        <CardText>
          <Table
            style={styles.table}
            selectable={false}
          >
            <TableBody
              selectable={false}
              displayRowCheckbox={false}
            >
              {
                waitlistStatuses.map(({ value, name }) => {
                  const row = find(counts, { status: value })
                  const count = row ? row.count : 0
                  return (
                    <TableRow key={value}>
                      <TableRowColumn>{name}</TableRowColumn>
                      <TableRowColumn>
                        <ValueLink
                          value={count}
                          path={path + `?filters[status]=${value}`}
                        />
                      </TableRowColumn>
                    </TableRow>
                  )
                })
              }
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn>Total</TableRowColumn>
                <TableRowColumn>
                  <ValueLink
                    value={total}
                    path={path}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        </CardText>
      </Card>
    )
  }
}

// @ts-ignore
WaitlistSummary.propTypes = {
  sessionSaleId: PropTypes.string.isRequired
}

export default WaitlistSummary
